export default __webpack_public_path__ + "static/media/service-4.555140d8.jpg";